<div class="btn-withTooltip" [ngClass]="{ notHover: onChooserColumnActive }">
  <gl-column-chooser
    [columns]="tableDatasource?.columns"
    (onChooserColumn)="onChooserColumn($event.detail.columns)"
    (onClick)="onChooserColumnActiveComponent()"
  >
  </gl-column-chooser>
  <div class="btn-withTooltip__item">
    {{ 'actions.filterColumns' | translate }}
  </div>
</div>
